/**
 * Estate Flow - Property Management Platform
 * Copyright © 2025 Sebastian Alliance Group LLC. All Rights Reserved.
 * 
 * PROPRIETARY AND CONFIDENTIAL
 */

import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('access_token');
  
  // If no token, redirect to home page
  if (!token) {
    return <Navigate to="/" replace />;
  }
  
  // Token exists, render the protected component
  return children;
};

export default PrivateRoute;
